export const frontStyleSparkedCocoSelector = ({frontStyleSparkedCoco}) => frontStyleSparkedCoco